__turbopack_context__.v({
  "outlineButton": "outline-button-module-scss-module__XwNccG__outlineButton",
});
